import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchPlayers, fetchPeriods, fetchCoaches } from '../../utils/ifrData';
import { isActive, periodKeyOf, periodLabel } from '../../utils/ifr';
import { titleByCode, COACH_TITLES } from '../../config/ifrTitles';
import { RATING_CATEGORIES, categoryInfo, fieldsFor } from '../../config/ratingCategories';
import { RS, TitleBadge } from './ratingUI';

// ── ORODHA RASMI YA IFR ─────────────────────────────────────────────────
// Hadharani. Hii ndio "rating list" — kama ya FIDE. Kasi tatu (Classical,
// Rapid, Blitz) zina orodha zake tofauti — kama FIDE, hazichanganyiki.

export default function RatingList() {
  const navigate = useNavigate();
  const [allPlayers, setAllPlayers] = useState([]);
  const [coaches, setCoaches] = useState([]);
  const [period, setPeriod] = useState(null);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [tab, setTab] = useState('players');
  const [cat, setCat] = useState('classical');
  const [showInactive, setShowInactive] = useState(false);

  useEffect(() => { load(); }, []);

  async function load() {
    try {
      const [ps, periods, cs] = await Promise.all([
        fetchPlayers(), fetchPeriods(), fetchCoaches(),
      ]);
      setAllPlayers(ps);
      setCoaches(cs);
      setPeriod(periods[0] || null);
    } catch (e) { console.error(e); }
    setLoading(false);
  }

  const F = fieldsFor(cat);
  const catInfo = categoryInfo(cat);
  const players = allPlayers
    .filter(p => p[F.established])
    .sort((a, b) => (b[F.ifr] || 0) - (a[F.ifr] || 0));

  const cur = periodKeyOf();
  const list = players.filter(p => {
    if (!showInactive && !isActive(p[F.lastActivePeriod], cur)) return false;
    if (!search.trim()) return true;
    const q = search.toLowerCase();
    return (p.fullName || '').toLowerCase().includes(q)
      || (p.clubName || '').toLowerCase().includes(q)
      || (p.school || '').toLowerCase().includes(q);
  });

  const inactiveCount = players.filter(p => !isActive(p[F.lastActivePeriod], cur)).length;

  return (
    <div style={RS.page}>
      <div style={RS.wrap}>

        <div onClick={() => navigate('/chess')} style={RS.back}>← Chess</div>

        <div style={RS.hero}>
          <div style={RS.heroLabel}>IYANNA FOUNDATION RATING</div>
          <h1 style={RS.h1}>Orodha Rasmi</h1>
          <div style={RS.heroText}>
            {period
              ? <>Imechapishwa {periodLabel(period.periodKey)} · michezo {period.gamesCount || 0}</>
              : <>Bado hakuna kipindi kilichochapishwa.</>}
          </div>
          <div onClick={() => navigate('/rating/system')} style={RS.heroLink}>
            Rating hizi zinapatikanaje? →
          </div>
        </div>

        <button onClick={() => navigate('/rating/print')} style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', width: '100%',
          background: '#fff', color: '#14452F', border: '1px solid #E8E4DA', padding: '12px 16px',
          borderRadius: '11px', fontSize: '13px', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit',
          marginBottom: '14px',
        }}>
          📄 Pakua Standings (PDF)
        </button>

        <div style={{ display: 'flex', gap: '7px', marginBottom: '14px' }}>
          {RATING_CATEGORIES.map(c => (
            <button key={c.key} onClick={() => setCat(c.key)} style={{
              flex: 1, padding: '10px', borderRadius: '11px', cursor: 'pointer',
              border: `1px solid ${cat === c.key ? c.color : '#E8E4DA'}`,
              background: cat === c.key ? c.color : '#fff', color: cat === c.key ? '#fff' : '#6B7280',
              fontSize: '12.5px', fontWeight: 700, fontFamily: 'inherit',
            }}>{c.label}</button>
          ))}
        </div>

        <div style={{ display: 'flex', gap: '8px', marginBottom: '14px' }}>
          {[
            { k: 'players', l: `Wachezaji (${players.length})` },
            { k: 'coaches', l: `Makocha (${coaches.length})` },
          ].map(t => (
            <button key={t.k} onClick={() => setTab(t.k)} style={{
              flex: 1, padding: '11px', borderRadius: '11px', cursor: 'pointer',
              border: `1px solid ${tab === t.k ? '#14452F' : '#E8E4DA'}`,
              background: tab === t.k ? '#14452F' : '#fff',
              color: tab === t.k ? '#fff' : '#6B7280',
              fontSize: '13px', fontWeight: 700, fontFamily: 'inherit',
            }}>{t.l}</button>
          ))}
        </div>

        {tab === 'players' ? (
          <>
            {cat !== 'classical' && (
              <div style={{ ...RS.card, background: '#FAF8F3', fontSize: '11.5px', color: '#6B7280', padding: '11px 14px', marginBottom: '12px' }}>
                {catInfo.label} haina Titles — kama FIDE, Titles ni za Classical pekee.
              </div>
            )}

            <input
              style={{ ...RS.input, marginBottom: '12px' }}
              placeholder="Tafuta jina, club au shule..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />

            {inactiveCount > 0 && (
              <label style={RS.check}>
                <input type="checkbox" checked={showInactive}
                  onChange={e => setShowInactive(e.target.checked)} />
                Onyesha wasio na shughuli ({inactiveCount})
              </label>
            )}

            {loading ? (
              <div style={RS.empty}>Inapakia…</div>
            ) : list.length === 0 ? (
              <div style={RS.empty}>
                {players.length === 0
                  ? `Bado hakuna mchezaji mwenye rating rasmi ya ${catInfo.label}. Rating ya kwanza inatolewa baada ya tukio la kwanza kuchapishwa.`
                  : 'Hakuna anayeendana na utafutaji wako.'}
              </div>
            ) : list.map((p, i) => {
              const inactive = !isActive(p[F.lastActivePeriod], cur);
              const last = (p[F.history] || []).slice(-1)[0];
              return (
                <div key={p.id} onClick={() => navigate(`/rating/player/${p.id}?cat=${cat}`)}
                  style={{ ...RS.row, opacity: inactive ? 0.55 : 1 }}>
                  <div style={RS.rank}>{i + 1}</div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '7px', flexWrap: 'wrap' }}>
                      {cat === 'classical' && p.title && <TitleBadge code={p.title} />}
                      <span style={RS.name}>{p.fullName}</span>
                    </div>
                    <div style={RS.meta}>
                      {p.clubName || p.school || '—'} · michezo {p[F.gamesRated] || 0}
                      {inactive && ' · hana shughuli'}
                    </div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={RS.rating}>{p[F.ifr]}</div>
                    {last?.change ? (
                      <div style={{
                        fontSize: '10.5px', fontWeight: 700, marginTop: '2px',
                        color: last.change > 0 ? '#059669' : last.change < 0 ? '#DC2626' : '#9CA3AF',
                      }}>
                        {last.change > 0 ? '+' : ''}{last.change}
                      </div>
                    ) : null}
                  </div>
                </div>
              );
            })}
          </>
        ) : (
          coaches.length === 0 ? (
            <div style={RS.empty}>Bado hakuna kocha aliyesajiliwa kwenye IFC.</div>
          ) : coaches.map((c, i) => {
            const t = COACH_TITLES.find(x => x.code === c.title);
            return (
              <div key={c.id} style={RS.row}>
                <div style={RS.rank}>{i + 1}</div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '7px', flexWrap: 'wrap' }}>
                    {t && (
                      <span style={{ ...RS.badge, background: `${t.color}18`, color: t.color }}>{t.code}</span>
                    )}
                    <span style={RS.name}>{c.name}</span>
                  </div>
                  <div style={RS.meta}>
                    {c.clubNames || '—'} · wanafunzi {c.studentsRated || 0}
                    {c.titledStudents ? ` · title ${c.titledStudents}` : ''}
                  </div>
                </div>
                <div style={RS.rating}>{c.ifc || '—'}</div>
              </div>
            );
          })
        )}

        <div style={RS.footer}>
          Rating zinachapishwa tarehe 1 ya kila mwezi. Kanuni zote ziko wazi
          kwenye{' '}
          <span onClick={() => navigate('/rating/system')} style={RS.inlineLink}>
            ukurasa wa mfumo
          </span>.
        </div>

      </div>
    </div>
  );
}

export { titleByCode };
